module.exports = __webpack_public_path__ + "static/media/workshop2.84441291.jpg";